<template>
  <span
    class="tag"
    :title="role.help"
    :class="role.tag"
    >{{ role.display }}</span
  >
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import { ROLES, type Role } from '@/config'

export default defineComponent({
  props: {
    role: {
      type: Object as PropType<Role>,
      required: true,
      validator: (value: unknown): boolean =>
        Object.values(ROLES).findIndex((role) => role === value) >= 0,
    },
  },
})
</script>
